import React, { memo } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

interface passwordIconProps {
  isVisible: boolean;
  size?: number;
}

const PasswordEyeIcon: React.FC<passwordIconProps> = memo(
  ({ isVisible, size = 18 }) => {
    return isVisible ? (
      <AiOutlineEyeInvisible size={size} />
    ) : (
      <AiOutlineEye size={size} />
    );
  }
);

export default PasswordEyeIcon;
